// Per-viewer browser storage. It can throw (private windows, blocked site
// data) or come back empty, so every access is wrapped and optional.

export function readLocal(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeLocal(key: string, value: string | null): void {
  try {
    if (value === null) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, value);
  } catch {
    // Storage unavailable — the value simply is not remembered.
  }
}

export const STORAGE_KEYS = {
  token: 'aa-play.session',
  theme: 'aa-play.theme',
  railCollapsed: 'aa-play.rail-collapsed',
  driveId: 'aa-play.drive-id',
  muted: 'aa-play.muted',
  driveHelpSeen: 'aa-play.drive-help-seen',
  spoilers: 'aa-play.spoilers',
} as const;
